// extracted by mini-css-extract-plugin
export default {"container":"Paginado_container__nSc-2","previousPage":"Paginado_previousPage__AAiCW","nextPage":"Paginado_nextPage__2D0Ju"};